var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "info-box-container" }, [
    _c("div", { staticClass: "info-box-text" }, [
      _c("p", {
        staticClass: "info-box-title",
        domProps: { innerHTML: _vm._s(_vm.title) },
      }),
      _c("p", {
        staticClass: "info-box-description",
        domProps: { innerHTML: _vm._s(_vm.description) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }